import LegalLayout from './LegalLayout';

const CookiesPage = () => (
  <LegalLayout title="Politique de cookies">
    <p data-testid="legal-cookies-intro">
      Le site <strong>odelicieuse.eu</strong> utilise un nombre limité de cookies et de
      technologies similaires (stockage local). Cette page explique leur rôle et comment les
      gérer.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">1. Qu'est-ce qu'un cookie ?</h2>
    <p>
      Un cookie est un petit fichier déposé sur votre appareil lors de la visite d'un site web.
      Il permet notamment de mémoriser vos préférences ou de vous reconnaître d'une visite à
      l'autre.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">2. Cookies utilisés</h2>

    <h3 className="text-lg font-semibold text-heading mt-4 mb-1">a. Cookies strictement nécessaires</h3>
    <p>
      Ces cookies sont indispensables au fonctionnement du site. Ils ne nécessitent pas votre
      consentement.
    </p>
    <ul className="list-disc pl-6 space-y-1">
      <li>
        <strong>Jeton d'authentification (localStorage)</strong> — garde votre session ouverte
        après la connexion. Durée : jusqu'à la déconnexion.
      </li>
      <li>
        <strong>Panier (localStorage)</strong> — mémorise les produits dans votre panier.
        Durée : persistante jusqu'à vidage.
      </li>
      <li>
        <strong>Préférences (localStorage)</strong> — retient votre langue et le thème
        clair/sombre. Durée : persistante.
      </li>
      <li>
        <strong>Consentement cookies</strong> — enregistre votre choix concernant la bannière
        cookies. Durée : 12 mois.
      </li>
    </ul>

    <h3 className="text-lg font-semibold text-heading mt-4 mb-1">b. Cookies de mesure d'audience</h3>
    <p>
      Nous pouvons utiliser un outil de mesure d'audience pour améliorer le site. Ces données
      sont anonymisées et ne nécessitent pas de consentement dans la mesure où elles restent
      purement statistiques internes.
    </p>

    <h3 className="text-lg font-semibold text-heading mt-4 mb-1">c. Cookies tiers</h3>
    <p>
      Nous n'utilisons pas de cookies publicitaires tiers, ni de pixels de tracking
      marketing.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">3. Comment gérer les cookies ?</h2>
    <p>Vous pouvez à tout moment :</p>
    <ul className="list-disc pl-6 space-y-1">
      <li>
        Modifier votre choix via le bouton <strong>« Gérer les cookies »</strong> présent dans
        le pied de page
      </li>
      <li>
        Supprimer les cookies et données locales via les paramètres de votre navigateur
        (Chrome, Firefox, Safari, Edge…)
      </li>
      <li>
        Naviguer en mode privé pour empêcher le stockage de cookies entre les sessions
      </li>
    </ul>
    <p className="text-sm text-muted mt-3">
      Note : la désactivation des cookies strictement nécessaires empêche le bon fonctionnement
      du site (impossible de rester connecté, panier perdu à chaque rechargement).
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">4. Mise à jour</h2>
    <p>
      Cette politique peut être modifiée à tout moment. La date de dernière mise à jour figure
      ci-dessous.
    </p>

    <p className="text-xs text-muted mt-8 italic">
      Dernière mise à jour : {new Date().toLocaleDateString('fr-BE', { day: '2-digit', month: 'long', year: 'numeric' })}.
    </p>
  </LegalLayout>
);

export default CookiesPage;
